import { FC } from 'react';
import { PartnersIntroductionDto } from '../../generated/api/front/models/PartnersIntroductionDto';
import { Icon } from '../Icon';
import { AnimationLayout } from './AnimationLayout';

interface PartnersModalProps {
  onClose: () => void;
  open: boolean;
  imgIndex: number;
  partners: PartnersIntroductionDto[];
}

export const PartnersModal: FC<PartnersModalProps> = ({
  onClose,
  open,
  imgIndex,
  partners,
}) => {
  const partner = partners[imgIndex];

  if (!partner) return null;

  return (
    <>
      <AnimationLayout open={open} onClose={onClose}>
        <div className="relative my-8 w-full max-w-4xl transform overflow-hidden bg-white shadow-xl transition-all">
          <button
            type="button"
            className="absolute right-3 top-3 text-white md:text-black"
            onClick={onClose}
          >
            <Icon.X className="h-6 w-6" />
          </button>

          <div className="flex flex-col md:flex-row">
            <img
              src={partner.modalImage}
              alt=""
              className="h-[200px] w-full object-cover md:h-[670px] md:w-fit"
              fetchPriority="high"
            />

            <div className="mt-0 h-[350px] space-y-6 overflow-y-scroll p-5 text-left md:mt-10 md:h-full md:space-y-10 md:overflow-y-auto md:p-8 lg:space-y-20">
              <div className="space-y-1">
                <p className="text-[20px] font-bold md:text-[34px]">
                  {partner.companyName}
                </p>
                <p className="text-[13px] text-slate-400 md:text-[16px]">
                  {partner.location}
                </p>
              </div>

              <p className="whitespace-pre-wrap text-[13px] text-slate-700 md:text-[14px]">
                {partner.description}
                <br />
                <br />
                {partner.address}
              </p>
            </div>
          </div>
        </div>
      </AnimationLayout>
    </>
  );
};
